
import React from "react";
import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface QuantityPresetSelectorProps {
  presets: string[];
  selectedValue: string;
  onSelect: (value: string) => void;
  style?: React.CSSProperties;
}

const AddItemQuantityPresets = ({ presets, selectedValue, onSelect, style }: QuantityPresetSelectorProps) => {
  const { theme } = useThemeConfig();
  if (presets.length === 0) return null;
  
  return (
    <div className="flex flex-wrap justify-center gap-2 w-full overflow-hidden" style={style}>
      {presets.map((value) => (
        <Button
          key={value}
          type="button"
          size="sm"
          onClick={() => onSelect(value)}
          variant={selectedValue === value ? "default" : "outline"}
          className="px-2 py-1 h-8 min-w-[40px] text-sm hover:bg-[var(--btn-bg-hover)]"
          style={{
            backgroundColor: selectedValue === value ? theme.warningColor : theme.backgroundColor,
            color: selectedValue === value ? theme.textPrimaryColor : theme.textColor,
            fontWeight: selectedValue === value ? 'bold' : undefined,
            '--btn-bg-hover': theme.primaryColor,
          } as React.CSSProperties}
        >
          {value}
        </Button>
      ))}
    </div>
  );
};

export default AddItemQuantityPresets;
